/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonthSettleVo
 */
export interface MonthSettleVo {
    /**
     * 月份（1-12）
     * @type {number}
     * @memberof MonthSettleVo
     */
    month?: number;
    /**
     * 出库单数（当月产生佣金的去重订单数）
     * @type {number}
     * @memberof MonthSettleVo
     */
    outboundOrderCount?: number;
    /**
     * 业绩（当月附加服务金额合计）
     * @type {number}
     * @memberof MonthSettleVo
     */
    performanceAmount?: number;
    /**
     * 分成（当月佣金金额合计，含已结算与未结算）
     * @type {number}
     * @memberof MonthSettleVo
     */
    commissionAmount?: number;
    /**
     * 是否已结清（当月全部佣金记录均已结算为true，存在未结算为false）
     * @type {boolean}
     * @memberof MonthSettleVo
     */
    settled?: boolean;
    /**
     * 结算文件名（仅已结清时返回）
     * @type {string}
     * @memberof MonthSettleVo
     */
    fileName?: string;
    /**
     * 结算文件路径（仅已结清时返回，为 presigned URL）
     * @type {string}
     * @memberof MonthSettleVo
     */
    filePath?: string;
}

/**
 * Check if a given object implements the MonthSettleVo interface.
 */
export function instanceOfMonthSettleVo(value: object): value is MonthSettleVo {
    return true;
}

export function MonthSettleVoFromJSON(json: any): MonthSettleVo {
    return MonthSettleVoFromJSONTyped(json, false);
}

export function MonthSettleVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthSettleVo {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : json['month'],
        'outboundOrderCount': json['outboundOrderCount'] == null ? undefined : json['outboundOrderCount'],
        'performanceAmount': json['performanceAmount'] == null ? undefined : json['performanceAmount'],
        'commissionAmount': json['commissionAmount'] == null ? undefined : json['commissionAmount'],
        'settled': json['settled'] == null ? undefined : json['settled'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'filePath': json['filePath'] == null ? undefined : json['filePath'],
    };
}

export function MonthSettleVoToJSON(json: any): MonthSettleVo {
    return MonthSettleVoToJSONTyped(json, false);
}

export function MonthSettleVoToJSONTyped(value?: MonthSettleVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'outboundOrderCount': value['outboundOrderCount'],
        'performanceAmount': value['performanceAmount'],
        'commissionAmount': value['commissionAmount'],
        'settled': value['settled'],
        'fileName': value['fileName'],
        'filePath': value['filePath'],
    };
}

